import { render, staticRenderFns } from "./MobileList.vue?vue&type=template&id=47051128&scoped=true"
import script from "./MobileList.vue?vue&type=script&lang=js"
export * from "./MobileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47051128",
  null
  
)

export default component.exports